import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SimpleToggle } from "../../_components";
import ToolTipWrapper from "../../_components/ToolTipWrapper";

type CreatePublicUrlToggleType = {
    initialState?: boolean;
    onChange: (value: boolean) => void;
    boldedName?: boolean;
    readOnly?: boolean;
    // Only where the PMS delivers the link on its own (Hostify): there this chat
    // message is an extra. Leave it off where it is the only delivery.
    optional?: boolean;
};

export default function SendInvitationURLFromPMSToggle({
    onChange,
    initialState,
    boldedName = true,
    readOnly = false,
    optional = false
}: CreatePublicUrlToggleType) {

    const [state, setState] = useState(initialState);
    const { t } = useTranslation();

    useEffect(() => setState(initialState), [initialState])

    return (
        <div className={`${readOnly ? 'cna' : ''} d-flex align-items-center justify-content-between`}>
            <ToolTipWrapper tooltip={t("invitation_public_url_send_via_pms_action_tooltip")}>
                <div className={`${boldedName ? 'font-weight-bold' : ''} position-relative`}>
                    {t("invitation_public_url_send_via_pms_action")}
                    {optional && <span className="text-muted"> ({t("global_optional")})</span>}
                </div>
            </ToolTipWrapper>
            <div className="ml-2"></div>
            <SimpleToggle
                readOnly={readOnly}
                checked={state}
                handleChange={({ detail: { value } }) => {
                    setState(value);
                    onChange(value);
                }}
            ></SimpleToggle>
        </div>
    );
}
